import { useEffect, useState, useContext } from 'react';
import ReservationOrderStatusService from '../services/reservation-order-status/reservation-order-status';
import { AuthenticationState } from './use-authentication';
import ServerContext from '../contexts/serverContext';
import { VehicleChecklistContent } from '../models/experiencefragments/vehicle-checklist';
import { VEHICLE_CHECKLIST_CARD_TYPE } from '../constants';

const useOrderStatus = (
    vin: string | undefined,
    checkListTiles: VehicleChecklistContent[] | undefined,
    authenticationState: AuthenticationState
) => {
    const [orderStatus, setOrderStatus] = useState<boolean>(false);
    const serverContext = useContext(ServerContext);

    useEffect(() => {
        if (
            vin &&
            checkListTiles?.some(
                tile =>
                    tile.cardTypes ===
                    VEHICLE_CHECKLIST_CARD_TYPE.RESERVATION_ORDER_STATUS
            ) &&
            authenticationState === AuthenticationState.Authenticated
        ) {
            new ReservationOrderStatusService()
                .request(serverContext.current3LetterCountryCode)
                .then(response => setOrderStatus(response));
        }
    }, [
        vin,
        authenticationState,
        serverContext.current3LetterCountryCode,
        checkListTiles,
    ]);

    return orderStatus;
};

export default useOrderStatus;
